import { render, staticRenderFns } from "./list.vue?vue&type=template&id=10af6007&scoped=true&"
import script from "./list.js?vue&type=script&lang=js&"
export * from "./list.js?vue&type=script&lang=js&"
import style0 from "./list.vue?vue&type=style&index=0&id=10af6007&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10af6007",
  null
  
)

export default component.exports